var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loadingAudit,
          expression: "loadingAudit",
        },
      ],
      staticClass: "yxtbiz-ojtaudit",
    },
    [
      _vm.isError
        ? _c(
            "div",
            [
              _c("yxtf-empty", {
                attrs: {
                  size: "medium",
                  "empty-text": _vm.$t("pc_biz_o2o_range_delete_tip"),
                },
              }),
            ],
            1
          )
        : [
            _c("div", { staticClass: "yxtbiz-ojtaudit__title" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.chooseType
                      ? _vm.$t("pc_biz_o2o_lbl_te_choose_stu" /* 导师选学员 */)
                      : _vm.$t(
                          "pc_biz_ojt_tit_student_choose_teacher" /* 学员选导师 */
                        )
                  ) +
                  "\n    "
              ),
            ]),
            _c("div", { staticClass: "mt24" }, [
              _c(
                "div",
                { staticClass: "yxtbiz-ojtaudit__info-wrapper" },
                _vm._l(_vm.auditLists, function (info) {
                  return _c(
                    "div",
                    {
                      key: info.name,
                      staticClass: "w-50p yxtbiz-ojtaudit__info-line",
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "color-gray-7 d-in-block lh22" },
                        [_vm._v(_vm._s(info.name))]
                      ),
                      _c(
                        "yxtf-tooltip",
                        { attrs: { "open-filter": "", placement: "top" } },
                        [
                          _c("yxtbiz-user-name", {
                            attrs: { slot: "content", name: info.value },
                            slot: "content",
                          }),
                          _c("yxtbiz-user-name", {
                            staticClass:
                              "color-gray-10 d-in-block lh22 ellipsis w-max-70p nowrap",
                            attrs: { name: info.value },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }